module.exports = __webpack_public_path__ + "static/media/go_plain.5d214512.svg";